import React, { useEffect, useState, FC } from "react"
import { KSpan, KTitleSpan } from "kahuna-base-react-components"
import AdminUserAdvance from "./user-advance/AdminUserAdvance"
import AdminProfitAndLoss from "./profit-and-loss/AdminProfitAndLoss"
import AdminPerformance from "./performance/AdminPerformance"
import { connect } from "react-redux"
import { RootState } from "../../../../store"
import { checkAdminPermission } from "../../../../utility"
import { ADMIN_PERMISSIONS } from "../../../../constants"

enum TabOptions {
  PERFORMANCE = "Performance",
  USER_ADVANCE = "User Advance",
  PROFIT_AND_LOSS = "P&L (Profit & Loss Overview)"
}

type AdminFinanceReportingProps = {
  userAdminPermissions?: string
}

const AdminFinanceReporting: FC<AdminFinanceReportingProps> = (props) => {
  const [openSidebar, setOpenSidebar] = useState<boolean>(true)
  const [selectedTab, setSelectedTab] = useState()

  const hasFinanceReportingPermission = () => {
    return (
      checkAdminPermission(ADMIN_PERMISSIONS.FINANCE_REPORTING_USER_ADVANCE, props.userAdminPermissions) ||
      checkAdminPermission(ADMIN_PERMISSIONS.FINANCE_REPORTING_PL, props.userAdminPermissions)
    )
  }

  return (
    <div className="catalog flex-grow justify-center">
      <div className="w-[100%] flex ">
        <div
          className={`${
            openSidebar ? "min-w-[230px]" : "min-w-0 !w-[0px]"
          } max-w-[320px] w-[20%] bg-[#F7F7F7] min-h-[100vh] flex flex-col overflow-hidden shrink-0`}
          style={{
            transitionDuration: "0.5s"
          }}
        >
          <div>
            <div className="py-1.5 px-4">
              <div className="p-2">
                <KTitleSpan text="Reporting" color="#111" fontSize={20} lineHeight="28px" />
              </div>

              {hasFinanceReportingPermission() && (
                <div
                  data-testid="left-bar-performance"
                  className={`rounded-[10px] p-2 flex flex-row gap-2 mt-4 items-center ${
                    selectedTab === TabOptions.PERFORMANCE ? "bg-[#FFF]" : "transparent"
                  } cursor-pointer whitespace-nowrap`}
                  onClick={() => {
                    if (selectedTab === TabOptions.PERFORMANCE) return
                    setSelectedTab(TabOptions.PERFORMANCE)
                  }}
                >
                  <KSpan text={"Performance"} fontSize={12} lineHeight="20px" fontWeight={500} color="#111" />
                </div>
              )}

              {checkAdminPermission(ADMIN_PERMISSIONS.FINANCE_REPORTING_USER_ADVANCE, props.userAdminPermissions) && (
                <div
                  data-testid="left-bar-user-advance"
                  className={`rounded-[10px] p-2 flex flex-row gap-2 mt-1 items-center ${
                    selectedTab === TabOptions.USER_ADVANCE ? "bg-[#FFF]" : "transparent"
                  } cursor-pointer whitespace-nowrap`}
                  onClick={() => {
                    if (selectedTab === TabOptions.USER_ADVANCE) return
                    setSelectedTab(TabOptions.USER_ADVANCE)
                  }}
                >
                  <KSpan text={"User Advance"} fontSize={12} lineHeight="20px" fontWeight={500} color="#111" />
                </div>
              )}

              {checkAdminPermission(ADMIN_PERMISSIONS.FINANCE_REPORTING_PL, props.userAdminPermissions) && (
                <div
                  data-testid="left-bar-profit-and-loss"
                  className={`rounded-[10px] p-2 flex flex-row gap-1 mt-1 items-center ${
                    selectedTab === TabOptions.PROFIT_AND_LOSS ? "bg-[#FFF]" : "transparent"
                  } cursor-pointer whitespace-nowrap`}
                  onClick={() => {
                    if (selectedTab === TabOptions.PROFIT_AND_LOSS) return
                    setSelectedTab(TabOptions.PROFIT_AND_LOSS)
                  }}
                >
                  <KSpan
                    text={"P&L (Profit & Loss Overview)"}
                    fontSize={12}
                    lineHeight="20px"
                    fontWeight={500}
                    color="#111"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="grow min-h-0">
          {selectedTab === TabOptions.PERFORMANCE && (
            <AdminPerformance openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
          )}
          {selectedTab === TabOptions.USER_ADVANCE && (
            <AdminUserAdvance openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
          )}
          {selectedTab === TabOptions.PROFIT_AND_LOSS && (
            <AdminProfitAndLoss openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    userAdminPermissions: state.auth.user.adminPermissions
  }
}

export default connect(mapStateToProps, {})(AdminFinanceReporting)
